module.exports = __webpack_public_path__ + "static/sustainable-energywithout-the-hot-air-d994fceba43b061dbef25457ef24bdad.jpg";